import React, { useContext } from 'react';
import { TableKeys } from '@communication-center/data-objects';
import classes from './AffectedNotificationsPrompt.module.scss';
import { TabsConfig } from '../../../../models';
import { WMButton, WMButtonVariant } from '@walkme/wm-ui';
import { CreateAudienceDialogContext } from '../CreateAudienceDialogContext';
import { Warning } from '@walkme/wm-ui-icons';
import { useTranslation } from 'react-i18next';

const keyPrefix = 'components.audiences.createAudienceDialog.affectedNotificationsPrompt';

const NotificationState = ({ tab }: { tab: TableKeys }) => {
    const { t } = useTranslation('', { keyPrefix });
    const { redirectToNotification, audience } = useContext(CreateAudienceDialogContext);
    const tableKey = TabsConfig[tab].tableKey;

    return (
        <span>
            <span className={classes.notifStateDesc}>
                {tableKey} {t('notifStateDesc', { count: audience!.notificationsStatus[tableKey] })}
            </span>

            <WMButton
                variant={WMButtonVariant.Text}
                className={classes.activeNotificationsButton}
                onClick={async () => redirectToNotification?.(tab)}
                tooltipProps={{ title: t('tooltipTitle', { tableKey }) }}
                area-label={t('tooltip-areaLabel', { tableKey })}
            >
                ({audience?.notificationsStatus[tableKey]})
            </WMButton>
        </span>
    );
};

const AffectedNotificationsPrompt = () => {
    const { t } = useTranslation('', { keyPrefix });
    const { dataTestId, audience } = useContext(CreateAudienceDialogContext);

    return (
        <div className={classes.warnPrompt} data-testid={`${dataTestId}-affected-notifications-prompt`}>
            <Warning style={{ marginRight: 10 }} />
            <div className={classes.promptText}>
                <div>
                    <b>{t('note')}</b>
                </div>
                <div className={classes.notificationsStatus}>
                    {audience?.notificationsStatus?.[TableKeys.ACTIVE] && <NotificationState tab={TableKeys.ACTIVE} />}
                    {audience?.notificationsStatus?.[TableKeys.SCHEDULED] && <NotificationState tab={TableKeys.SCHEDULED} />}
                    {audience?.notificationsStatus?.[TableKeys.DRAFTS] && <NotificationState tab={TableKeys.DRAFTS} />}
                </div>
            </div>
        </div>
    );
};

export default AffectedNotificationsPrompt;
